export const screens = [
    {
        id: "recipes",
        kit: "Food",
        preview: require("./food/recipes-preview.png"),
        regular: require("./food/recipes.jpg"),
        full: require("./food/recipes.png")
    },
    {
        id: "categories",
        kit: "Food",
        preview: require("./food/categories-preview.png"),
        regular: require("./food/categories.jpg"),
        full: require("./food/categories.png")
    },
    {
        id: "recipe",
        kit: "Food",
        preview: require("./food/recipe-preview.png"),
        regular: require("./food/recipe.jpg"),
        full: require("./food/recipe.png")
    },
    {
        id: "ingredients",
        kit: "Food",
        preview: require("./food/ingredients-preview.png"),
        regular: require("./food/ingredients.jpg"),
        full: require("./food/ingredients.png")
    },
    {
        id: "restaurants",
        kit: "Food",
        preview: require("./food/restaurants-preview.png"),
        regular: require("./food/restaurants.jpg"),
        full: require("./food/restaurants.png")
    },
    {
        id: "restaurant",
        kit: "Food",
        preview: require("./food/restaurant-preview.png"),
        regular: require("./food/restaurant.jpg"),
        full: require("./food/restaurant.png")
    },
    {
        id: "reservation",
        kit: "Food",
        preview: require("./food/reservation-preview.png"),
        regular: require("./food/reservation.jpg"),
        full: require("./food/reservation.png")
    },
    {
        id: "timeline",
        kit: "Social",
        preview: require("./social/timeline-preview.png"),
        regular: require("./social/timeline.jpg"),
        full: require("./social/timeline.png")
    },
    {
        id: "story",
        kit: "Social",
        preview: require("./social/story-preview.png"),
        regular: require("./social/story.jpg"),
        full: require("./social/story.png")
    },
    {
        id: "comments",
        kit: "Social",
        preview: require("./social/comments-preview.png"),
        regular: require("./social/comments.jpg"),
        full: require("./social/comments.png")
    },
    {
        id: "newpost",
        kit: "Social",
        preview: require("./social/newpost-preview.png"),
        regular: require("./social/newpost.jpg"),
        full: require("./social/newpost.png")
    },
    {
        id: "messages",
        kit: "Social",
        preview: require("./social/messages-preview.png"),
        regular: require("./social/messages.jpg"),
        full: require("./social/messages.png")
    },
    {
        id: "chat",
        kit: "Social",
        preview: require("./social/chat-preview.png"),
        regular: require("./social/chat.jpg"),
        full: require("./social/chat.png")
    },
    {
        id: "profile",
        kit: "Social",
        preview: require("./social/profile-preview.png"),
        regular: require("./social/profile.jpg"),
        full: require("./social/profile.png")
    },
    {
        id: "library",
        kit: "Music",
        preview: require("./music/library-preview.png"),
        regular: require("./music/library.jpg"),
        full: require("./music/library.png")
    },
    {
        id: "album",
        kit: "Music",
        preview: require("./music/album-preview.png"),
        regular: require("./music/album.jpg"),
        full: require("./music/album.png")
    },
    {
        id: "playlists",
        kit: "Music",
        preview: require("./music/playlists-preview.png"),
        regular: require("./music/playlists.jpg"),
        full: require("./music/playlists.png")
    },
    {
        id: "playlist",
        kit: "Music",
        preview: require("./music/playlist-preview.png"),
        regular: require("./music/playlist.jpg"),
        full: require("./music/playlist.png")
    },
    {
        id: "playercontrols",
        kit: "Music",
        preview: require("./music/playercontrols-preview.png"),
        regular: require("./music/playercontrols.jpg"),
        full: require("./music/playercontrols.png")
    },
    {
        id: "profilealbums",
        kit: "Music",
        preview: require("./music/profile-albums-preview.png"),
        regular: require("./music/profile-albums.jpg"),
        full: require("./music/profile-albums.png")
    },
    {
        id: "profileplaylists",
        kit: "Music",
        preview: require("./music/profile-playlists-preview.png"),
        regular: require("./music/profile-playlists.jpg"),
        full: require("./music/profile-playlists.png")
    },
    {
        id: "photographylibrary",
        kit: "Photography",
        preview: require("./photography/library-preview.png"),
        regular: require("./photography/library.jpg"),
        full: require("./photography/library.png")
    },
    {
        id: "photo",
        kit: "Photography",
        preview: require("./photography/photo-preview.png"),
        regular: require("./photography/photo.jpg"),
        full: require("./photography/photo.png")
    },
    {
        id: "filters",
        kit: "Photography",
        preview: require("./photography/filters-preview.png"),
        regular: require("./photography/filters.jpg"),
        full: require("./photography/filters.png")
    },
    {
        id: "cropping",
        kit: "Photography",
        preview: require("./photography/cropping-preview.png"),
        regular: require("./photography/cropping.jpg"),
        full: require("./photography/cropping.png")
    },
    {
        id: "photographyalbums",
        kit: "Photography",
        preview: require("./photography/albums-preview.png"),
        regular: require("./photography/albums.jpg"),
        full: require("./photography/albums.png")
    },
    {
        id: "places",
        kit: "Photography",
        preview: require("./photography/places-preview.png"),
        regular: require("./photography/places.jpg"),
        full: require("./photography/places.png")
    },
    {
        id: "camera",
        kit: "Photography",
        preview: require("./photography/camera-preview.png"),
        regular: require("./photography/camera.jpg"),
        full: require("./photography/camera.png")
    },
    {
        id: "guides",
        kit: "Travel",
        preview: require("./travel/guides-preview.png"),
        regular: require("./travel/guides.jpg"),
        full: require("./travel/guides.png")
    },
    {
        id: "guide",
        kit: "Travel",
        preview: require("./travel/guide-preview.png"),
        regular: require("./travel/guide.jpg"),
        full: require("./travel/guide.png")
    },
    {
        id: "travelbooking",
        kit: "Travel",
        preview: require("./travel/booking-preview.png"),
        regular: require("./travel/booking.jpg"),
        full: require("./travel/booking.png")
    },
    {
        id: "cities",
        kit: "Travel",
        preview: require("./travel/cities-preview.png"),
        regular: require("./travel/cities.jpg"),
        full: require("./travel/cities.png")
    },
    {
        id: "city",
        kit: "Travel",
        preview: require("./travel/city-preview.png"),
        regular: require("./travel/city.jpg"),
        full: require("./travel/city.png")
    },
    {
        id: "travelrestaurants",
        kit: "Travel",
        preview: require("./travel/restaurants-preview.png"),
        regular: require("./travel/restaurants.jpg"),
        full: require("./travel/restaurants.png")
    },
    {
        id: "travelhotels",
        kit: "Travel",
        preview: require("./travel/hotels-preview.png"),
        regular: require("./travel/hotels.jpg"),
        full: require("./travel/hotels.png")
    },
    {
        id: "login",
        kit: "Login",
        preview: require("./login/login-preview.png"),
        regular: require("./login/login.jpg"),
        full: require("./login/login.png")
    },
    {
        id: "signup-email",
        kit: "Login",
        preview: require("./login/signup-email-preview.png"),
        regular: require("./login/signup-email.jpg"),
        full: require("./login/signup-email.png")
    },
    {
        id: "signup-name",
        kit: "Login",
        preview: require("./login/signup-name-preview.png"),
        regular: require("./login/signup-name.jpg"),
        full: require("./login/signup-name.png")
    },
    {
        id: "signup-password",
        kit: "Login",
        preview: require("./login/signup-password-preview.png"),
        regular: require("./login/signup-password.jpg"),
        full: require("./login/signup-password.png")
    }
];



// WEBPACK FOOTER //
// ./src/elements/screen-images/index.ts